import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Tooltip } from 'next-common-lib';
import i18n from 'i18n';
import DeleteButton from 'components/Common/Buttons/DeleteButton';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import * as boardActions from 'redux/ducks/Board/BoardDucks';

export const InputBoard = () => {
  const dispatch = useDispatch();
  const boardList = useSelector(state => state.board.boardList);

  return (
    <>
      <Button
        componentType="normal"
        label={i18n.t('BTY_W_T_ADD_BORAD_INFO')}
        className="add"
        iconInfo={{ className: 'ic-plus ', size: 'sm' }}
        disabled={boardList?.length === 3}
        tabIndex={0}
        onClick={() => {
          dispatch(wizardActions.openPopup({}));
        }}
      />

      {boardList?.map(item => {
        return (
          <div className="view-box board" key={item.brdNm}>
            <Tooltip componentType="move" label={[`${item.brdNm}`]} placement="bottom">
              <div className="view-box-content">
                <p className="main-text">{item.brdNm}</p>
                <p className="main-text">{item.enBrdNm}</p>
              </div>
            </Tooltip>
            {item.portlet === 'Y' && (
              <div className="home">
                <p className="tiny-text">{i18n.t('BTY_W_T_DISPLAY_HOME')}</p>
              </div>
            )}
            <DeleteButton
              handleOnclick={() => {
                dispatch(boardActions.deleteBoard(item));
                item.portlet === 'Y' && dispatch(boardActions.deletePortlet({ selectedItem: item.portletNo }));
              }}
            />
          </div>
        );
      })}
    </>
  );
};

InputBoard.propTypes = {};
InputBoard.defaultProps = {};
export default InputBoard;
